// ===========================================
// hooks/useSearchStore.js
// ===========================================
import { useState, useEffect, useCallback } from 'react';

export const useSearchStore = () => {
  // Get initial values from localStorage
  const getInitialSearchTerm = () => {
    return localStorage.getItem('current_search_term') || '';
  };

  const getInitialFilters = () => {
    const saved = localStorage.getItem('current_search_filters');
    return saved ? JSON.parse(saved) : {
      author: '',
      uploadDate: '',
      fileSize: ''
    };
  };

  const [searchTerm, setSearchTerm] = useState(getInitialSearchTerm);
  const [searchHistory, setSearchHistory] = useState([]);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState(getInitialFilters);

  // Load search history from localStorage
  useEffect(() => {
    const history = localStorage.getItem('search_history');
    if (history) {
      setSearchHistory(JSON.parse(history));
    }
  }, []);

  // Persist search term to localStorage
  useEffect(() => {
    if (searchTerm) {
      localStorage.setItem('current_search_term', searchTerm);
    } else {
      localStorage.removeItem('current_search_term');
    }
  }, [searchTerm]);

  // Persist filters to localStorage
  useEffect(() => {
    localStorage.setItem('current_search_filters', JSON.stringify(selectedFilters));
  }, [selectedFilters]);

  const addToHistory = useCallback((term) => {
    if (!term.trim()) return;
    
    setSearchHistory(prev => {
      if (prev.includes(term)) return prev;
      const newHistory = [term, ...prev.slice(0, 9)];
      localStorage.setItem('search_history', JSON.stringify(newHistory));
      return newHistory;
    });
  }, []);

  const clearSearchHistory = useCallback(() => {
    setSearchHistory([]);
    localStorage.removeItem('search_history');
  }, []);

  return {
    searchTerm,
    setSearchTerm,
    searchHistory,
    searchSuggestions,
    setSearchSuggestions,
    selectedFilters,
    setSelectedFilters,
    addToHistory,
    clearSearchHistory
  };
};